import { useState } from "react";
import { heroData } from "@/mocks/homeData";

export default function HeroSection() {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <section className="relative w-full min-h-[420px] md:min-h-[480px] lg:min-h-[520px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroData.backgroundImage}
          alt="ママと子供の温かい写真"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/60 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
        <div className="max-w-2xl">
          {/* Main Title */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
            {heroData.title}
          </h1>
          <p className="text-base md:text-lg text-foreground-700 mb-8">
            {heroData.subtitle}
          </p>

          {/* Search Bar */}
          <div className="relative">
            <div className="flex items-center bg-white rounded-full border-2 border-background-200 px-4 py-3 md:py-4 shadow-sm">
              <i className="ri-search-line text-foreground-400 text-lg mr-3"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="何を探していますか？"
                className="flex-1 bg-transparent outline-none text-sm md:text-base text-foreground-800 placeholder:text-foreground-400"
              />
              <button className="bg-primary-500 text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
                検索
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}